//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "BowReview",
    props: {
        author: {
            default: "",
            type: String,
        },
        htmlTag: {
            default: null,
            type: String,
        },
        link: {
            default: null,
            type: Object,
        },
        text: {
            default: "",
            type: String,
        },
    },
    data: () => ({}),
};
